import { useQuery } from '@tanstack/react-query';
import { fetchCustomArticleLifeTime } from '@hub/bearing-hub/libs/BearingsLifetime/fetchCustomArticleLifeTime';
import type { IbhCatalogArticleLifetimeParams, IbhCustomArticleLifetimeParams } from '@igus/iglidur-bearing-hub-api';
import { fetchCatalogArticleLifeTime } from './fetchCatalogArticleLifeTime';

export const useArticleLifeTime = (
  enabled: boolean,
  articleLifetimeParams: IbhCatalogArticleLifetimeParams | IbhCustomArticleLifetimeParams,
  shouldRecalculateLifeTime: boolean
) => {
  const queryKey = ['articleLifetime', shouldRecalculateLifeTime];
  let articleFunction: (
    articleLifetimeParams: IbhCatalogArticleLifetimeParams | IbhCustomArticleLifetimeParams
  ) => Promise<number>;
  if ('shape' in articleLifetimeParams) {
    articleFunction = fetchCustomArticleLifeTime;
  } else {
    articleFunction = fetchCatalogArticleLifeTime;
  }

  const {
    data: lifetime,
    isFetching,
    isLoading,
    status,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: () => articleFunction(articleLifetimeParams),
    enabled,
    gcTime: 0,
  });

  return { lifetime, isFetching, isLoading, status, recalculateLifeTime: refetch };
};
